export enum HttpStatusCodes {
  InternalServerError = 500,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404
}
